import Ajax from 'Utils/ajax';
export const topMenu = (data) => Ajax.post("admin/topmenu",data);
export const sideMenu = data => Ajax.post("admin/sidemenu", data);
export const logOut = data => Ajax.post("admin/logOut", data);
export const routeVerification = data => Ajax.post("admin/pageVerification", data); //sagar add this api for page verification 14-07-2023
export const getHeaderEvents = data => Ajax.post("hr/getHeaderEvents", data);